export default "__VITE_ASSET__M$tU$5MU__"